import type { Crm } from '@ps/web-martech-cms-types';

import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetEffectParams, WidgetModelConfig } from '@swf/core/store';
import { login } from '@swf/core/utils/actions';

const effects = {
  async preload(payload: undefined, params: WidgetEffectParams<Crm>) {
    const {
      widget: { zone_id: zoneId },
      dispatch,
      actions
    } = params;
    const loadZone = async () => {
      if (zoneId) {
        await dispatch.crm.fetchZone({ zoneId });
      }
    };
    loadZone();
    login(actions)?.subscribe(loadZone);
  }
};

export type EmptyState = object;

export interface CrmWidgetModel extends WidgetModelConfig<Crm, EmptyState> {
  effects: typeof effects;
}

export const crmWidgetModel: CrmWidgetModel = {
  state: {},
  effects,
  reducers: {}
};

export const useCrmWidget: UseWidget<Crm, CrmWidgetModel> = useWidget;
